import { useMaybeUser } from 'src/hooks/use-user'
import { useAuthCookies } from 'src/hooks/use-auth'
import { useSession } from 'src/hooks/use-session'
import { AffiliateCode } from 'src/graphql/types'

export function useAffiliateCode() {
  const data = useMaybeUser()
  const { data: sessionData } = useSession()
  const { affiliate: cookieAffiliateCode } = useAuthCookies()
  const sessionAffiliateCode = sessionData?.session?.affiliateCode
  const userAffiliateCode = data?.user?.affiliate?.code

  const affiliateCode =
    userAffiliateCode ?? sessionAffiliateCode ?? cookieAffiliateCode

  return affiliateCode
}

export function useIsAffiliate(code: AffiliateCode) {
  const affiliateCode = useAffiliateCode()
  if (affiliateCode === code) return true
  return false
}

export function useIsCsconfederationAffiliate() {
  return useIsAffiliate(AffiliateCode.Csconfederation)
}
